import { useFormikContext } from 'formik';
import { regionLangMap, useGetRegionLabel } from '../share';
import { FV } from './share';
import { useReactScrollContext } from 'views/Aide/components/ReactScrollContext';
import { Container, linkProps } from 'views/Aide/Scenario/PolicyForm/NoRegionForm/Nav';
import { Link } from 'react-scroll';
import { CheckCircleFilled } from '@ant-design/icons';

function Nav() {
  const { t, getRegionLabel } = useGetRegionLabel();

  const {
    errors,
    values: { regionTemplateMap },
  } = useFormikContext<FV>();

  const { containerId, basicId, createRegionContextId } = useReactScrollContext();

  return (
    <Container>
      <Link to={basicId} containerId={containerId} {...linkProps}>
        {!errors.wabaId &&
        !errors.category &&
        !errors.group &&
        !errors.name &&
        typeof errors.regionTemplateMap !== 'string' ? (
          <CheckCircleFilled />
        ) : (
          <span />
        )}
        {t('aide.基础配置')}
      </Link>
      {Object.keys(regionLangMap).map((region) => {
        if (!regionTemplateMap[region] || regionTemplateMap[region].cancelled) {
          return null;
        }
        return (
          <Link
            key={region}
            to={createRegionContextId(region)}
            containerId={containerId}
            {...linkProps}
          >
            {errors.regionTemplateMap?.[region] ? <span /> : <CheckCircleFilled />}
            {getRegionLabel(region)}
          </Link>
        );
      })}
    </Container>
  );
}

export default Nav;
